import { Link } from "@tanstack/react-router";
import { type RoamdocJobPost } from "#/db/schema";
import MDXRemote from "#/components/MdxRemote";
import {
  PlusCircleIcon,
  BuildingOffice2Icon,
} from "@heroicons/react/24/outline";
import { toJobPosting } from "#/lib/router-links";

export default function SimilarPostingsList({
  postings,
}: {
  postings: RoamdocJobPost[];
}) {
  return (
    <div
      id="job-postings"
      className="mx-8 space-y-5"
      itemType="http://schema.org/ItemList"
      itemScope
    >
      {postings.map((posting, index) => (
        <PostingItem key={posting.id} posting={posting} index={index} />
      ))}
    </div>
  );
}

function PostingItem({
  posting,
  index,
}: {
  posting: RoamdocJobPost;
  index: number;
}) {
  const facility = posting.facility;

  const titleSplit = posting.title?.split(" job in ");
  const jobTitle = titleSplit?.[0]?.trim() ?? "";
  const location = `${posting?.cityName}, ${posting?.stateId}`;

  const word =
    [
      "needed",
      "opportunity",
      "position",
      "opening",
      "wanted",
      "career",
      "hiring",
      "recruiting",
      "availablility",
      "vacancy",
      "employment",
    ][index] ?? "job";

  return (
    <div className="rounded-lg border border-stone-400 bg-white p-5">
      <Link className="no-underline" {...toJobPosting(posting.slug ?? "", posting.shortId ?? "")}>
        <h3
          className="mb-3 border-b border-stone-200 pb-2 text-xl font-normal"
          itemProp="name"
        >
          <span className="text-3xl text-sky-500">{`${jobTitle} ${word}`}</span>
          <br />
          <span className="pl-1">{` in ${location}`}</span>
        </h3>
      </Link>
      {facility && (
        <p className="mb-4 flex w-full space-x-2">
          <BuildingOffice2Icon className="h-5 w-5" />{" "}
          <span>{posting.facility?.name}</span>
        </p>
      )}
      <div className="space-y-1 text-gray-500">
        <MDXRemote source={posting.description?.slice(0, 200) ?? ""} />
      </div>

      <div className="mt-10 flex">
        <button
          type="button"
          className="flex w-full items-center justify-center space-x-2 rounded-lg bg-green-600 px-4 py-4 text-xl text-white shadow-lg hover:bg-green-700"
          role="dialog"
          aria-modal="true"
          aria-labelledby="Compare job posting"
        >
          <PlusCircleIcon className="h-6 w-6" />
          <span>Compare</span>
        </button>
      </div>
    </div>
  );
}
